import { styled } from '@mui/material/styles';
import { Container } from '@mui/material';

const AdminContainer = styled(Container)(({ theme }) => ({
  // 铺满整个主内容区域，去掉 MUI Container 默认的 lg 最大宽度限制
  maxWidth: 'none !important',
  [theme.breakpoints.down('md')]: {
    paddingLeft: '0px',
    paddingRight: '0px'
  }
}));

export default AdminContainer;
